export default {
	'app.language.en-US': 'English',

	'app.Yes': 'Yes',
	'app.No': 'No',

	'user.onHold':
		'You cannot place an order at this time, please contact your Business Manager for further details.',

	'chooseColor.isPack':
		'This configurable item is a component of a pack. Please enter Add to Cart Qty before selecting Choose Color.',
	'chooseColor.NegativeQuantity': 'Number must be positive',

	'dates.start_date_after_end': 'Start must be before end date.',
	'dates.too_far_back': 'Only the last 12 months are allowed.',
	'dates.cant_see_future': 'You cannot select a future date.',
	'dates.invalid_start_date': 'Start date is not a valid date.',
	'dates.invalid_end_date': 'End date is not a valid date.',

	'orderdetails.status.InProcess': 'In Process',
	'orderdetails.status.Open': 'Open',
	'orderdetails.status.Completed': 'Completed',
	'orderdetails.NotAvailable': 'Order {orderNumber} is not available.',
	'orderDetails.headerText': 'SOLO Order Details: ',

	OrderHistory_InvalidInput: 'Input invalid. Try again with different values.',

	'itemSearch.invalidQuery': 'Invalid item name.',
	'itemSearch.invalidNumber': 'Invalid item number',
	'item.See_Components': 'See Components',
	'item.soldOut': 'Sold Out',
	'item.CannotOrderItems':
		'You cannot place an order as you are not shopping as a franchisee.',
	'itemdetails.ItemDetails_Unauthorized': 'Item is not available.',
	'packdetails.ItemSearch_InvalidInput': 'Pack is not available',

	'addtocart.InvalidQuantity':
		'Quantity entered is invalid, please enter a valid quantity.',
	'addtocart.GreaterQuantity':
		'Quantity entered is more than the available quantity {available_quantity}, please enter a valid quantity.',
	'addtocart.SubmitError':
		'There is only {available_quantity_on_submit} available quantity, please update before resubmitting.',
	'addtocart.SubmitErrorSoldOut':
		'Item is sold out. Please remove before resubmitting.',
	'addtocart.CartGreaterQuantity':
		'You have {quantity_in_cart} items in cart, you cannot add more than {available_quantity}.',
	'addtocart.Cart_InvalidItems': 'Some items have invalid quantities.',
	'addtocart.MaximumQuantity':
		'You already ordered maximum quantity. You cannot order more.',
	'addtocart.EmptyField':
		'Quantity entered is invalid, please enter a valid one.',
	'addtocart.ItemIsPreview': 'You cannot order items from a PREVIEW promotion.',
	'addtocart.Unauthorized_Method': 'Unauthorized for ordering items.',
	'addtocart.Cart_ItemIsPreview': 'Items in preview cannot be added to cart.',
	'addtocart.Cart_ItemNotFoundInPromotions': 'Item not found in promotions.',
	'addtocart.Cart_NotEnoughAvailableQuantity':
		'You cannot add more than available quantity.',
	'addtocart.DropShip_ItemNotInCart': 'Item is not in cart.',
	'addtocart.InternalServerError':
		'There was a problem submitting your order, please refresh the page or try again later.',
	'addtocart.Submit_InvalidRequest':
		'There was a problem submitting your order, please refresh the page or try again later.',
	'addtocart.Cart_InvalidRequest':
		'Sorry, we are currently experiencing technical problems, please try again later.',
	/* Api error codes */
	'addtocart.request_failed':
		'Sorry, we are currently experiencing technical problems, please try again later.',
	'impersonation.request_failed':
		'Sorry, we are currently experiencing technical problems, please try again later.',
	'itemdetails.request_failed':
		'Sorry, we are currently experiencing technical problems, please try again later.',
	'packdetails.request_failed':
		'Sorry, we are currently experiencing technical problems, please try again later.',
	'offerings.request_failed':
		'Sorry, we are currently experiencing technical problems, please try again later.',
	request_failed:
		'Sorry, we are currently experiencing technical problems, please try again later.',
	'addtocart.Cart_IncorrectConfigurationsAddedInCart':
		'Configurable item has an invalid configuration. Please add the required quantity.',
	'impersonation.Impersonation_404':
		'The LN Business Partner #: {userId} was not found. Please check the number and try again.',
	'impersonation.Impersonation_Unauthorized':
		'This franchisee is not available. Please enter another franchisee to search for.',
	'impersonation.impersonatedAs':
		'You are viewing SOLO as {name}{bpnumber}. Press revert to browse as yourself.',
	'impersonation.instruction':
		'If this is correct, press Continue, otherwise Search for another Business Partner #',
	'impersonation.User_Unauthorized':
		'User {userId} is not available. Please enter another LN Business Partner.',

	'offerings.ItemCategory_InvalidCategory': 'This category is not available. ',
	'offerings.ItemSearch_InvalidInput': 'This category is not available. ',

	'cart.dropShip':
		'To drop ship an item to more than one address, add it to the cart for each address',
	'cart.newAddress.EmptyName': 'Shop name is missing',
	'cart.newAddress.InvalidName': 'Incorrect shop name',
	'cart.newAddress.GreaterThanName':
		'The Shop field cannot have more that 35 characters. Please re-enter this field.',
	'cart.newAddress.EmptyTechnician': 'Technician name is missing',
	'cart.newAddress.GreaterThanTechnician':
		'The Technician field cannot have more that 30 characters. Please re-enter this field.',
	'cart.newAddress.InvalidTechnician': 'Incorrect technician name',
	'cart.newAddress.EmptyAddress1': 'First address is missing',
	'cart.newAddress.GreaterThanAddress1':
		'The Address Line1 field cannot have more that 100 characters. Please re-enter this field.',
	'cart.newAddress.InvalidAddress1': 'Incorrect first address',
	'cart.newAddress.GreaterThanAddress2':
		'The Address Line2 field cannot have more that 100 characters. Please re-enter this field.',
	'cart.newAddress.InvalidAddress2': 'Incorrect second address',
	'cart.newAddress.EmptyCity': 'City is missing',
	'cart.newAddress.InvalidCity': 'Incorrect city name',
	'cart.newAddress.GreaterThanCity':
		'The City field cannot have more that 30 characters. Please re-enter this field',
	'cart.newAddress.EmptyZip': 'ZIP/Postal Code is missing',
	'cart.newAddress.InvalidZip': 'Incorrect zip',
	'cart.newAddress.GreaterThanZip':
		'The Zip/PostalCode field cannot have more that 10 characters. Please re-enter this field.',
	'cart.newAddress.EmptyPhone': 'Phone is missing',
	'cart.newAddress.InvalidPhone':
		'Please enter the phone number in the following format: ###-###-####.',
	'cart.newAddress.InvalidPhoneAUS':
		'Please enter the phone number including area code: ##########',
	'cart.newAddress.GreaterThanPhone':
		'The Phone field cannot have more than {max_length} characters. Please re-enter this field.',
	'cart.newAddress.EmptyEmail': 'Email is missing',
	'cart.newAddress.InvalidEmail': 'Please enter a valid email address',
	'cart.newAddress.GreaterThanEmail':
		'The Email field cannot have more that 50 characters. Please re-enter this field.',
	'cart.newAddress.CustomerCare':
		'If you believe the information you submitted is correct, please contact Customer Care Center at {customerPhone}.',
	'cart.newAddress.DuplicateDropship':
		'A drop ship with the shop name "{dropshipName}" already exists',

	'general.addToCart': 'Add to cart',
	'general.cancelText': 'Cancel',
	'general.chooseColorText': 'Choose color',
	'general.pleaseFillInMessage':
		'Please fill in the quantities for the desired promotions',
	'general.continueShopping': 'Continue shopping',
	'general.noItemsAvailable': 'No items available.',
	'general.errorLoadingContent': 'Error loading content ',
	'general.pleaseFillInTitle': 'Please fill in quantities',

	'header.yourCart': 'Your Cart',

	'navigation.home': 'Home',
	'navigation.orderHistory': 'SOLO Order History',
	'navigation.orderStatus': 'Order Status',
	'navigation.salesReports': 'Sales Reports',
	'navigation.help': 'Help',

	'leftSideMenu.downloadSoloDetails': 'Download SOLO Details',
	'leftSideMenu.previewText': '*PREVIEW* ',

	'home.pleaseNoteMessage':
		'Please note: QTY does not represent velocity center stock but the quantity set aside for the Solo promotion.',
	'hand-tools': 'Hand Tools',
	'power-tools': 'Power Tools',
	'tool-storage': 'Tool Storage',
	'shop-and-tech': 'Shop and Tech',
	diagnostics: 'Diagnostics',

	'productGroup.itemsIn': 'Item(s) in',

	'offeringsPage.headerText': 'Offerings',
	'offeringsPage.itemsIn': 'Items in',
	'offeringsPage.print': 'Print',

	'itemSearch.headerText': 'Search results for ',
	'itemSearch.genericHeaderText': 'Search',
	'itemSearch.itemsIn': 'Item(s)',
	'itemSearch.searchButton': 'Search',
	'itemSearch.placeholderText': 'Item # Search',
	'itemSearch.noItemsFound': 'No items were found for this search.',

	'orderHistory.itemsIn': 'Item(s)',
	'orderHistory.startDate': 'Start:',
	'orderHistory.endDate': 'End:',
	'orderHistory.showResults': 'Show results',
	'orderHistory.concernMessage':
		'If you have questions or concerns regarding an order, please contact the Customer Care Center at ',
	'orderHistory.viewOrderHistoryTab': 'View SOLO Order History',
	'orderHistory.searchPartNumberTab': 'Search Part Number',
	'orderHistory.noOrdersFound':
		'No orders were found for the selected month. Please select a different month.',
	'orderHistory.webReports':
		'Order Status for all Snap-on orders is available in ',
	'orderHistory.webReportsLink': 'Web Reports',
	'searchPart.title': 'Product # SOLO Order History:',
	'searchPart.searchText': 'Search for Part #:',
	'searchPart.itemsFound': 'Item(s) found',
	'searchPart.noOrdersFound':
		'No orders were found for this part number. Please select a different part number.',
	'searchPart.searchPlaceholder': 'Search for part number',

	'orderDetails.orderType': 'Order Type:',
	'orderDetails.orderDate': 'Order Date:',
	'orderDetails.franchiseeNumber': 'Franchisee Number:',
	'orderDetails.poNumber': 'PO Number:',
	'orderDetails.orderReference': 'Order Reference:',
	'orderDetails.totalOrderList': 'Total Order List:',
	'orderDetails.totalOrderNet': 'Total Order Net:',
	'orderDetails.backToSearchPart': 'Back to Search Part Number',
	'orderDetails.backToOrderHistory': 'Back to SOLO Order History',
	'orderDetails.backToHome': 'Back to Home Page',

	'itemDetails.headerText': 'Item Details',

	'packDetails.headerText': 'Pack Details',
	'packDetails.totalItemsInPackage': '{totalCount} total items in package',
	'packDetails.itemsInPackText': ' Items in pack',

	'cart.headerText': 'Your Shopping Cart',
	'cart.submitOrder': 'Submit Order',
	'cart.updateCart': 'Update Cart',
	'cart.cartSummary': 'Cart Summary: ',
	'cart.itemsIn': ' item(s)',
	'cart.leaveCartMessage':
		'You have changes that are not saved. If you click "Cancel", changes will be lost. Please update cart now.',
	'cart.cartUpdatedMessage': 'Cart has been updated.',
	'cart.noItemsAddedMessage':
		'No items have been added to your cart. Please continue shopping and click the "Add to Cart" button for items you wish to purchase.',
	'cart.itemsAddedMessage': 'Items Added to your cart',
	'cart.viewCartMessage': ' VIEW CART',
	'cart.footerTotals': 'Totals',
	'cart.footerItemsText': ' items',
	'cart.submitWithoutUpdate':
		'You have unsaved changes. Submit without updating the cart?',
	'cart.orderSubmitted': 'Order Submitted',
	'cart.thankYouMessage':
		'Thank-you! Your order has been submitted successfully.',
	'cart.emailConfirmationMessage':
		'You will receive an email confirmation with the details of your order.',
	'cart.leaveCartTitle': 'Leave Cart',
	'cart.submitWithoutUpdatesYes': 'YES',

	'dropShip.newDropshipTitle': 'New Drop Ship Address',
	'dropship.editDropshipTitle': 'Edit Drop Ship Address',
	'dropship.nameLabel': 'Name',
	'dropship.technicianLabel': 'Technician',
	'dropship.address1Label': 'Address 1',
	'dropship.address2Label': 'Address 2',
	'dropship.countryLabel': 'Country',
	'dropship.stateLabel': 'State/Province',
	'dropship.cityLabel': 'City',
	'dropship.zipLabel': 'ZIP/Postal Code',
	'dropship.phoneLabel': 'Phone #',
	'dropship.emailLabel': 'Email Address',
	'dropship.optionNone': 'None',
	'dropship.optionNewAddress': 'New Address',
	'dropship.optionEditAddress': 'Edit Address',
	'dropship.NotificationTitle': 'Drop Ship Notification',
	'dropship.Notification':
		'You have already updated the dropship on the same item twice. Please update the cart before updating dropship again.',
	'dropship.unvalidatedAddress':
		'Could not verify this address. Please confirm your entry or correct it necessary.',
	'dropship.chooseAddress': 'Please select your address',
	'impersonation.modalTitle': 'Search for Franchisee or Company Store',
	'impersonation.enterBPNumberText': 'Please enter the LN Business Partner #',
	'impersonation.pressContinueText':
		'If this is correct, press Continue, otherwise Search for another Business Partner # above.',
	'impersonation.continueButton': 'Continue',
	'impersonation.reverButton': 'Revert',
	'impersonation.informationFoundText':
		'The following information was found for LN Business Partner #:',
	'impersonation.lnBusinessPartnerLabel': 'LN Business Partner #:',
	'impersonation.nameLabel': 'Name:',
	'impersonation.managerLabel': 'Manager:',
	'impersonation.phoneLabel': 'Phone:',
	'impersonation.emailLabel': 'Email:',
	'impersonation.statusLabel': 'Status:',
	'impersonation.searchPlaceholder': 'LN Business Partner',
	'impersonation.searchForLNBP': 'Search for LN BP#',
	'impersonation.expiredTitle': 'Impersonation has expired',
	'impersonation.expiredText':
		'Impersonation has been reverted due to inactivity',

	'itemsTable.soloItemColumn': 'Solo Item',
	'itemsTable.promoNameColumn': 'Promo Name',
	'itemsTable.endDateColumn': 'End Date',
	'itemsTable.qtyColumn': 'Qty',
	'itemsTable.listColumn': 'List',
	'itemsTable.promoColumn': 'Promo',
	'itemsTable.TAColumn': 'T/A',
	'itemsTable.netColumn': 'Net',
	'itemsTable.estShipColumn': 'Est. Ship Date',
	'itemsTable.numberHoldInvWksColumn': '# of Hold Inv Wks',
	'itemsTable.dropShipColumn': 'Drop Ship',
	'itemsTable.addToCartQtyColumn': 'Add to Cart Qty',
	'itemsTable.soloItemPackNameColumn': 'Solo Item/ Pack Name',
	'itemsTable.startDateColumn': 'Start Date',
	'itemsTable.itemQtyColumn': 'Item Qty',
	'itemsTable.extColumn': 'Ext.',
	'itemsTable.cartSoloItemColumn': 'Solo Item/Pack Name',
	'itemsTable.cartPromoColumn': 'Promo',
	'itemsTable.cartQty': 'Cart Qty',
	'itemsTable.cartShipDateColumn': 'Est. Ship Date',
	'itemsTable.cartDropShipColumn': 'Drop Ship Address',
	'itemsTable.removeColumn': 'Remove',
	'itemsTable.resultsPerPage': 'Results per page',
	'ordersTable.orderDateColumn': 'Order Date',
	'ordersTable.PONumberColumn': 'PO Number',
	'ordersTable.orderReference': 'Order Reference',
	'ordersTable.orderTypeColumn': 'Order Type',
	'ordersTable.shipToNameColumn': 'Ship to Name',
	'ordersTable.totalColumn': 'Total {currency}',
	'ordersTable.partNumberColumn': 'Part #',
	'ordersTable.descriptionColumn': 'Description',
	'ordersTable.orderedQtyColumn': 'Ordered Qty',
	'ordersTable.estShipColumn': 'Est. Ship Date',
	'ordersTable.unitPriceColumn': 'Unit Price',
	'ordersTable.extendedPriceColumn': 'Extended Price',
	'ordersTable.lineNumberColumn': '#',
	'ordersTable.productNumberColumn': 'Product #',
	'ordersTable.qtyColumn': 'Qty',
	'ordersTable.planDeliveryDateColumn': 'Planned Delivery Date',

	'chooseColor.modalTitle': 'Select Color',
	'chooseColor.mustSelectError': 'You must select {totalQuantity} items.',
	'chooseColor.itemQuantityBelowError':
		'Selected item quantity must be below {quantity}',
	'chooseColor.selectTotalQty': 'Select {total} Total Qty - Selected ',
	'chooseColor.notOnFile': 'not on file',
	'chooseColor.qtyText': 'Qty:',

	'downloadPromotion.clickOnTypeMessage':
		'Click on what type of file you want to download for ',
	'downloadPromotion.downloadPDF': 'Download PDF file',
	'downloadPromotion.downloadExcel': 'Download Excel file',
	'downloadPromotion.promotionText': 'Promotion',
	'downloadPromotion.categoryText': 'Category',

	Unauthorized_Method: 'Unauthorized for ordering items.',

	'errorLoading.temporaryProblemText':
		"There's a temporary problem when loading the content for this page.",
	'errorLoading.ifYouContinueMessage':
		'If you continue to get this message please contact the Customer Care Center at {customerPhone}.',

	'confirmPromptModal.titleText': 'Confirm',

	'unauthorizedMessage.noPermissionsText':
		'You do not have permission to access this page',
	'unauthorizedMessage.noPermissionsText2':
		"It appears that you don't currently have permission to access this page.",
	'unauthorizedMessage.nationalCareCenterMessage':
		'If you believe this is an error please contact the Customer Care Center at {customerPhone}.',

	'packItemList.packContains': 'This pack contains {itemCount} items',
	'packItemList.itemNumberColumn': 'Item #',
	'ok.Button': 'OK',
	'cancel.Button': 'Cancel',
	'edit.Button': 'Edit',
	'confirm.Button': 'Confirm',
	'general.privacyPolicy': 'Privacy Policy',
};



// WEBPACK FOOTER //
// ./src/ui/i18n/messages/en_US.js